module.exports = __webpack_public_path__ + "static/media/tam-vo.1d931bb3.png";